import React, { useContext } from 'react'
import Provider, { EmailVerificationContext, EmailVerificationContextProvider } from './Provider'

import { PointrThemedContainer, NotificationPage } from 'components'
import useEmailVerificationStyles from './Styles'
import { Button } from '@material-ui/core'
import { IEmailVerificationProps } from './interface'

import SessionManagerService from 'smart-components/session-manager/Service'

const EmailVerificationPage: React.FC = () => {
  const classes = useEmailVerificationStyles({})
  const { state, handlers } = useContext<EmailVerificationContext>(EmailVerificationContextProvider)

  return (
    <PointrThemedContainer>
      <div className={classes.root}>
        <div className={classes.container}>
          <NotificationPage
            warning
            size="big"
            title="You need to validate your email"
            subtitle={`Please check you email for a confirmation link. Click on the link sent to <i>${SessionManagerService.state.currentUser?.email}</i> to confirm your email address.`}
          />

          <div className={classes.buttonContainer}>
            <Button
              id="re-send-confirmation-email-button"
              variant="contained"
              disabled={state.isReSendingEmail}
              onClick={handlers.resendEmail}
            >
              Re-send confirmation email
            </Button>
          </div>
        </div>
      </div>
    </PointrThemedContainer>
  )
}

export default (props: IEmailVerificationProps) => (
  <Provider {...props}>
    <EmailVerificationPage />
  </Provider>
)
